import * as yup from 'yup'

export function createDecorator(
  factory: (object: any, propertyName: string) => any = () => void 0
) {
  const schema = yup.object()

  return (object: any, propertyName: string) => {
    const ret = factory(object, propertyName)

    let fields: Record<string, any> | void = Reflect.getMetadata('fields', object)

    if (!fields) {
      fields = {}
    }

    fields[propertyName] = ret || schema

    Reflect.defineMetadata('fields', fields, object)
  }
}

export function createProxyDecorator(
  data: any,
  callback: (object: any, propertyName: string, schema: any) => any = () => void 0
) {
  let schema = data

  const decorator = (object: any, propertyName: string) => {
    let fields: Record<string, any> | void = Reflect.getMetadata('fields', object)

    if (!fields) {
      fields = {}
    }

    const ret = callback(object, propertyName, schema)

    if (ret) {
      fields[propertyName] = ret
    } else {
      fields[propertyName] = schema
    }

    Reflect.defineMetadata('fields', fields, object)
  }

  const proxy = new Proxy(decorator, {
    apply(target: any, thisArg: any, argArray?: any): any {
      return Reflect.apply(target, thisArg, argArray)
    },

    get(target: any, p: PropertyKey): any {
      if (Reflect.has(schema, p)) {
        const property = schema[p]

        if (typeof property === 'function') {
          return (...args: any[]) => {
            schema = schema[p](...args)
            return proxy
          }
        } else {
          return property
        }
      }
      return void 0
    }
  })

  return proxy
}
